import { render, staticRenderFns } from "./cModalAddPosDetail.vue?vue&type=template&id=b953e138&scoped=true"
import script from "./cModalAddPosDetail.vue?vue&type=script&lang=js"
export * from "./cModalAddPosDetail.vue?vue&type=script&lang=js"
import style0 from "./cModalAddPosDetail.vue?vue&type=style&index=0&id=b953e138&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b953e138",
  null
  
)

export default component.exports